import Text from '@atoms/Text';
import texts from './en.json';
import { Image } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { supportEmail, supportPhoneNumber } from '@helpers/constants';
import { appendCountryCodeAndFormatMobile } from '@helpers/miscelleanous';

const MobileRmConsultationBanner = ({
    showRMDetails,
    rmDetails,
    whatsappLink,
    title,
    className = '',
    isOpportunityListing = false,
}) => {
    return showRMDetails || !isOpportunityListing ? (
        <div
            className={`px-4 py-8 bg-[url('/images/opportunities/RmCounsulationWaves.svg')] mt-4 ${className}`}
        >
            <div className="space-y-6">
                <div className="flex flex-col gap-2">
                    <Text
                        content={title}
                        className="h6-semibold text-primary-500"
                    />
                    <Text
                        content={
                            showRMDetails
                                ? texts.ConsultWithYourRm
                                : texts.ConsultWithUsForAssistance
                        }
                        className="p5-regular text-gray-500"
                    />
                </div>
                {showRMDetails ? (
                    <div className="flex flex-col gap-4">
                        <div className="h-14 flex gap-2 rounded-l-full bg-opportunity-help-mobile-inner-bg items-center">
                            <Image
                                src={`${
                                    rmDetails?.profileImageLink
                                        ? rmDetails.profileImageLink
                                        : '/images/user-solid.svg'
                                }`}
                                className={`w-14 h-14 border-4 ${
                                    !rmDetails?.profileImageLink
                                        ? 'border-2 border-gray-400 bg-gray-400'
                                        : 'border-4 border-secondary-300'
                                } rounded-full`}
                            />
                            <div className="flex flex-col gap-1">
                                <Text
                                    className="h6-semibold text-gray-900"
                                    content={rmDetails?.name || '-'}
                                />
                                <Text
                                    className="p5-regular text-gray-500"
                                    content={texts.AvailableTimings}
                                />
                            </div>
                        </div>
                        <div className="flex gap-4 justify-center">
                            {rmDetails?.calendlyLink ? (
                                <a
                                    href={rmDetails.calendlyLink}
                                    target="_blank"
                                    className="flex flex-1"
                                >
                                    <Button
                                        buttonType="secondary"
                                        buttonSize="small"
                                        className="text-primary-500 flex-1 h7-semibold"
                                        buttonText={texts.BookConsultation}
                                    />
                                </a>
                            ) : null}
                            {rmDetails?.mobile ? (
                                <>
                                    <a
                                        href={`tel:${appendCountryCodeAndFormatMobile(
                                            rmDetails.mobile,
                                            '+91'
                                        )}`}
                                    >
                                        <div className="p-2 border-primary-500 rounded-xl border-1">
                                            <Image
                                                src="/images/phone.svg"
                                                alt="phone"
                                                className="h-6 w-6"
                                            />
                                        </div>
                                    </a>
                                    <a href={whatsappLink} target="_blank">
                                        <div className="p-2 border-primary-500 rounded-xl border-1">
                                            <Image
                                                src="/images/whatsapp-icon.svg"
                                                alt="whatsapp"
                                                className="h-6 w-6"
                                            />
                                        </div>
                                    </a>
                                </>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col gap-3">
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col  bg-basicWhite/80  rounded-xl p-3 gap-2">
                                <div className="flex gap-2">
                                    <Image
                                        src="/images/phone-gradient.svg"
                                        className="h-6 w-6"
                                        alt="phone"
                                    />
                                    <Text
                                        className="h7-semibold text-gray-900"
                                        content={'Call'}
                                    />
                                </div>
                                <a href={`tel:${supportPhoneNumber}`}>
                                    <Button
                                        buttonType="textunderline"
                                        buttonSize="small"
                                        buttonText={supportPhoneNumber}
                                        className="text-primary-500 p4-underline !w-full !text-start !justify-start"
                                    />
                                </a>
                            </div>
                            <div className="flex flex-col  bg-basicWhite/80  rounded-xl p-3 gap-2">
                                <div className="flex gap-2">
                                    <Image
                                        src="/images/message-gradient.svg"
                                        className="h-6 w-6 px-[2px] py-[3px]"
                                        alt="phone"
                                    />
                                    <Text
                                        className="h7-semibold text-gray-900"
                                        content={'Email'}
                                    />
                                </div>
                                <a
                                    href={`mailto:${supportEmail}`}
                                    target="_blank"
                                >
                                    <Button
                                        buttonType="textunderline"
                                        buttonSize="small"
                                        buttonText={supportEmail}
                                        className="text-primary-500 p4-underline !w-full !text-start !justify-start"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    ) : null;
};

export default MobileRmConsultationBanner;
